module.exports = __webpack_public_path__ + "img/shop-popcat-click.a7362134.png";